/* eslint-disable vue/valid-v-bind */
<template>
    <v-card height='100%'>
      <v-container fluid class="pa-5">
        <v-row>
          <v-col cols="12">
            <p>
              {{stock.toUpperCase()}} 
              Volume - 
              <span id='volume'></span> 
              Daily Variation Breakdown vs. Median 90d
            </p>
            <VolumeBreakdownChart
              :id="stock"
              :apiEndpoint="'/get-stock-volume-breakdown/'"
              date-key="date"
              :bar-keys="[
                'MedianVolume',              
                'Country',
                'Market',
                'Mom',
                'Quality',
                'Residuals',
                'Risk',
                'Sector',
                'Size',
                'Value',
                'ReducedDemand',
              ]"
              :barColors="[
                '#00868a',
                '#0c2243',
                '#e9507f',  
                '#865986',
                '#bbc7da',
                '#3a99ec',
                '#38edd5',
                '#f8cbd9',
                '#f47a7a',
                '#ffff7f',
                '#FC6E51',
                '#A0CECB',
              ]"
              line-key="Volume"
            />
          </v-col>
        </v-row>
      </v-container>
    </v-card>
</template>

<script>
  import VolumeBreakdownChart from "@/components/VolumeBreakdownChart";
  export default {
    name: 'StockAnalyzeComponentChartVolume',
    props:['stock'],
    components: {
      VolumeBreakdownChart
    },    
  }
</script>
